// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__f4o1X","col":"styles_col__3Q3rn","actions":"styles_actions__1xAsz","conflict":"styles_conflict__1dNza"};